import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import styles from './ItemsPicker.scss';
import TextField from './TextField';
import Button from './Button';
import FormField from './form/FormField';

export default class ItemsPicker extends PureComponent {
    static propTypes = {
        items: PropTypes.array,
        onAddItem: PropTypes.func.isRequired,
        onRemoveItem: PropTypes.func.isRequired,
        error: PropTypes.string,
        label: PropTypes.string,
    };

    static defaultProps = {
        items: [],
        error: null,
        label: '',
    };

    state = {
        value: '',
    };

    handleFieldChange = ({target: {value}}) => {
        this.setState({value});
    };

    handleAddItem = () => {
        const {value} = this.state;
        const {onAddItem} = this.props;

        if (!value && value.trim().length === 0) {
            return;
        }

        if (onAddItem) {
            onAddItem(value);
        }

        this.setState({value: ''});
    };

    handleRemoveItem = (value) => () => {
        const {onRemoveItem} = this.props;

        if (onRemoveItem) {
            onRemoveItem(value);
        }
    };

    render() {
        const {value} = this.state;
        const {items, error, label} = this.props;


        return (
            <FormField label={label}
                       className={styles.container}
                       error={error}
            >
                <div className={styles.inputsWrapper}>
                    <TextField
                        value={value}
                        onChange={this.handleFieldChange}
                        className={styles.itemInput}
                        error={error}
                    />
                    <Button
                        label={loc('add-label')}
                        onClick={this.handleAddItem}
                        className={styles.addButton}
                    />
                </div>
                {items && Boolean(items.length) &&
                <div className={styles.itemsList}>
                    {items.map((item, key) =>
                        <div
                            className={styles.itemContainer}
                            key={key}
                        >
                            {item}
                            <div
                                className={styles.deleteButton}
                                onClick={this.handleRemoveItem(item)}
                            />
                        </div>
                    )}
                </div>}
            </FormField>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/controls/ItemsPicker.js